import type { ReactElement } from 'react';
import { ErrorCode } from '@gr/core/errors';
import { BLOG_ROLES, BlogRole } from '@gr/core/accounts/workspaces/dto';
import { useT } from '../../../../app/di';
import { Button } from '../../../../ui-kit/Button/Button';
import { FieldRow, FieldRowActions, FieldRowGrow } from '../../../../ui-kit/FieldRow/FieldRow';
import { FormAlert, FormSelectField, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

export interface NewMemberValues {
  login: string;
  role: BlogRole;
}

/** WS-UC-4: добавить участника по логину с ролью. */
export function AddMemberForm({ onSubmit }: { onSubmit(values: NewMemberValues): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<NewMemberValues>({
    defaultValues: { login: '', role: BlogRole.Editor },
    fields: ['login', 'role'],
    onSubmit,
    afterSuccess: (values) => ({ ...values, login: '' }),
  });
  const { control, formState } = form;
  return (
    <form className="u-stack" onSubmit={submit} noValidate>
      <FormAlert form={form} />
      <FieldRow>
        <FieldRowGrow>
          <FormTextField control={control} name="login" label={t('workspaces.members.login')} rules={{ required: ErrorCode.FieldRequired }} disabled={formState.isSubmitting} />
        </FieldRowGrow>
        <FormSelectField
          control={control}
          name="role"
          label={t('workspaces.members.role')}
          options={BLOG_ROLES.map((value) => ({ value, label: t(`workspaces.roles.${value}`) }))}
          disabled={formState.isSubmitting}
        />
        <FieldRowActions>
          <Button type="submit" variant="primary" loading={formState.isSubmitting}>
            {t('common.add')}
          </Button>
        </FieldRowActions>
      </FieldRow>
    </form>
  );
}
